// extracted by mini-css-extract-plugin
export default {"portfolio":"Portfolio_portfolio__ctZSd","portfolio_projects":"Portfolio_portfolio_projects__wrQ7A"};